import { Bootstrapper, whenIdle, whenVisible } from '@sitepark/dom-bootstrapper';

Bootstrapper.register('data-sp-collapsible', async () => (await import('@sitepark/component-collapsible')).Collapsible);

Bootstrapper.register('data-sp-consent-banner', async () => (await import('@sitepark/component-consent')).ConsentBanner);

Bootstrapper.register('data-sp-pageperdaypagination', async () => (await import('../components/PerDayPaginationSlider')).PerDayPaginationSlider);

Bootstrapper.register('data-sp-pagination', async () => (await import('../components/PerPagePaginationSlider')).PerPagePaginationSlider);

Bootstrapper.register('data-sp-protectioncookiesusage', async () => (await import('@sitepark/component-consent')).DataProtectionCookiesUsage);
